import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleFilterDisplay, updateUriRef } from '../../../actions/filterActions';
import { injectIntl, defineMessages } from 'react-intl';
import { SbSharedRefineMenuSearchInput } from '../SbSharedRefineMenuSearchInput/SbSharedRefineMenuSearchInput';
import styles from './SbSharedRefineMenuSearchWithin.scss';
import get from 'lodash.get';
import { FILTER_REFINE_SEARCH } from '../sbSharedRefineMenuConstants';
import { pageTypeConstants as pageTypes } from '../../../constants/pageTypeConstants';
import { QP_SEARCH_QUERY } from '../../../constants/queryParamConstants';
import { createNewFilterUriRef } from '../../../utils/uriUtils';

const messages = defineMessages({
    placeholder: {
        id: 'sb.SbSharedRefineMenu.searchWithin.placeholder',
        defaultMessage: `Search within {totalResultsCount, plural, one {# result} other {# results}}`,
    },
    placeholderNoCount: {
        id: 'sb.SbSharedRefineMenu.searchWithin.placeholderNoCount',
        defaultMessage: `Search within results`,
    },
});

export class SbSharedRefineMenuSearchWithinComponent extends React.Component {
    constructor(props) {
        super(props);

        const appliedSearchFilter = props.itemSearch.appliedFilters.find(
            filter => filter.name === FILTER_REFINE_SEARCH
        );
        const inputValue = get(appliedSearchFilter, 'values.0.urlLabel') || '';

        this.state = {
            inputValue,
        };

        this.onInput = this.onInput.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.filtersShown && !newProps.filtersShown) {
            this.handleSearchSubmit();
        }
    }

    onInput(e) {
        this.setState({
            inputValue: e.target.value,
        });
    }

    onSubmit(e) {
        e.preventDefault();
        this.handleSearchSubmit();
    }

    handleSearchSubmit() {
        if (this.state.inputValue === '') {
            return;
        }
        // apply filters with new value
        this.props.updateFilters(this.state.inputValue, this.props.generatedUriRef);
        this.setState({ inputValue: '' });
        this.props.onSubmit();
    }

    render() {
        const { intl, horizontalSpacing, itemSearch, size, hideResultsCount } = this.props;
        const { totalResults: totalResultsCount, pageType } = itemSearch;
        const { inputValue } = this.state;
        const placeholder = intl.formatMessage(
            hideResultsCount ? messages.placeholderNoCount : messages.placeholder,
            {
                totalResultsCount,
            }
        );
        return pageType !== pageTypes.SEARCH ? (
            <SbSharedRefineMenuSearchInput
                autoComplete="on"
                className={styles.container}
                horizontalSpacing={horizontalSpacing}
                onInput={this.onInput}
                onSubmit={this.onSubmit}
                placeholder={placeholder}
                size={size}
                value={inputValue}
            />
        ) : null;
    }
}

SbSharedRefineMenuSearchWithinComponent.propTypes = {
    intl: PropTypes.object.isRequired,
    filtersShown: PropTypes.bool.isRequired,
    horizontalSpacing: PropTypes.oneOf(['small', 'medium']),
    onSubmit: PropTypes.func.isRequired,
    itemSearch: PropTypes.object.isRequired,
    size: PropTypes.oneOf(['medium', 'large']),
    updateFilters: PropTypes.func.isRequired,
    hideResultsCount: PropTypes.bool,
    generatedUriRef: PropTypes.string,
};

SbSharedRefineMenuSearchWithinComponent.defaultProps = {
    appliedSearchValue: '',
    horizontalSpacing: 'medium',
    onSubmit: () => {},
    size: 'medium',
    hideResultsCount: false,
};

const mapStateToProps = ({ filters }) => ({
    filtersShown: filters.filtersShown,
    generatedUriRef: filters.generatedUriRef,
});

function mapDispatchToProps(dispatch) {
    return {
        updateFilters(value, generatedUriRef) {
            const filterName = FILTER_REFINE_SEARCH;
            const filterValue = {
                urlLabel: value,
            };
            const uriRef = createNewFilterUriRef(generatedUriRef, QP_SEARCH_QUERY, value);

            dispatch(updateUriRef({ filterName, filterValue, uriRef }));
            dispatch(toggleFilterDisplay(false));
        },
    };
}

export const SbSharedRefineMenuSearchWithin = injectIntl(
    createFragmentContainer(
        connect(mapStateToProps, mapDispatchToProps)(SbSharedRefineMenuSearchWithinComponent),
        {
            itemSearch: graphql`
                fragment SbSharedRefineMenuSearchWithin_itemSearch on ItemSearchQueryConnection {
                    pageType
                    totalResults
                    appliedFilters {
                        name
                        values {
                            urlLabel
                        }
                    }
                }
            `,
        }
    )
);
